import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import assetManagementReducer from "./features/assetManagementSlice";
import dataAccuracySlice from "./features/dataAccuracySlice";
import templateSlice from "./features/templateSlice";
import businessInsightsReducer from "./features/businessInsightsSlice";
import actionItemsReducer from "./features/actionItemsSlice";
import metaEntitiesReducer from "./features/metaEntitiesSlice";
import forecastersReducer from "./features/forecastersSlice";
import manualExpenseSlice from "./features/manualExpenseSlice";
import pageSpeedPerforanceReducer from "./features/pageSpeedPerformanceSlice";
import websiteActionReducer from "./features/websiteActionSlice";
import pageGroupReducer from "./features/pageGroupSlice";
import themeReducer from "./features/themeSlice";
import activityNoteReducre from "./features/activityNoteSlice";
import ETLProcessListReducer from "./features/etlProcessListSlice";
import websiteTargetSlice from "./features/websiteTargetSlice";
import monitoringReducer from "./features/monitoringSlice";
import dataStoreReqReducer from "./features/dataStoreReqSlice";
import businessLeaderDashboardSlice from "./features/businessLeaderDashboardSlice";
import dataCollectionBrandsReducer from "./features/dataCollectionBrandsSlice";
import monitoringPackagesReducer from "./features/monitoringPackagesSlice";
import engagementIncentivesReducer from "./features/engagementIncentivesSlice";
import monitoringProcessLogsReducer from "./features/monitoringProcessLogsSlice";
import uniqueDefinitionReducer from "./features/uniqueDefSlice";
import mapsReducer from "./features/mapsSlice";
import unifierCalculationTypesReducer from "./features/unifierCalculationTypesSlice";
import trendsReducer from "./features/trendsSlice";
import genericCommentsAndFilesReducer from "./features/genericCommentsAndFilesSlice";
import activityNotesSlice from "./features/activityNotesSlice";
import landingPageExperienceReducer from "./features/landingPageExperienceSlice";
import scopesTabSTReducer from "./features/scopesTabSlice";
import searchTermTabReducer from "./features/searchTermTabSlice";
import aiRecomandationTabReducer from "./features/aiRecomendationTabSlice";
import receiptReducer from "./features/financeReceiptSlice";
import authReducer from "./features/authSlice";
import brandConfigurationReportReducer from "./features/brandConfigurationReportSlice";
import deviceReducer from "./features/deviceSlice";
import workspaceReducer from "./features/workspaceSlice";
import etlSeqReducer from "./features/etlSeqSlice";
import dealsPromotionsReducer from "./features/dealsPromotionsSlice";
import bizDevelopmentDashboardReducer from "./features/bizDevelopmentDashboardSlice";
import bizDevelopmentDashboardMobileReducer from "./features/bizDevelopmentDashboardMobileSlice";
import leadsManagementReducer from "./features/leadsManagementSlice";
import bizDevelopmentAnomaliesReducer from "./features/bizDevelopmentAnomaliesSlice";
import optifundDashboardReducer from "./features/optifundDashboardSlice";
import brandsReducer from "./features/brandsSlice";
import deepViewReducer from "./features/deepViewSlice";
import advisorReducer from "./features/advisorSlice";
import familiesReducer from "./features/familiesSlice";
import fetcherSettingsReducer from "./features/fetcherSettingsSlice";
const store = configureStore({
  reducer: {
    user: userReducer,
    assetManagement: assetManagementReducer,
    dataAccuracy: dataAccuracySlice,
    activityNotes: activityNotesSlice,
    actionItems: actionItemsReducer,
    businessInsights: businessInsightsReducer,
    metaEntity: metaEntitiesReducer,
    forecasters: forecastersReducer,
    template: templateSlice,
    websiteTarget: websiteTargetSlice,
    manualExpense: manualExpenseSlice,
    websiteAction: websiteActionReducer,
    pageSpeedPerformance: pageSpeedPerforanceReducer,
    pageGroup: pageGroupReducer,
    theme: themeReducer,
    activityNote: activityNoteReducre,
    ETLProcessList: ETLProcessListReducer,
    monitoring: monitoringReducer,
    dataStoreReq: dataStoreReqReducer,
    businessLeaderDashBoard: businessLeaderDashboardSlice,
    dataCollectionBrands: dataCollectionBrandsReducer,
    monitoringPackages: monitoringPackagesReducer,
    engagementIncentives: engagementIncentivesReducer,
    monitoringProcessLogs: monitoringProcessLogsReducer,
    uniqueDefinition: uniqueDefinitionReducer,
    maps: mapsReducer,
    unifierCalculationTypes: unifierCalculationTypesReducer,
    trends: trendsReducer,
    genericCommentsAndFiles: genericCommentsAndFilesReducer,
    landingPageExperience: landingPageExperienceReducer,
    searchTermOperation: scopesTabSTReducer, //scopes tab state for search term operation
    searchTermTab: searchTermTabReducer, //search term tab state for search term operation
    aiRecomandationTab: aiRecomandationTabReducer,
    receipts: receiptReducer,
    auth: authReducer,
    brandConfigurationReport: brandConfigurationReportReducer,
    device: deviceReducer,
    workspace: workspaceReducer,
    etlSeq: etlSeqReducer,
    dealsPromotions: dealsPromotionsReducer,
    bizDevelopmentDashboard: bizDevelopmentDashboardReducer,
    bizDevelopmentDashboardMobile: bizDevelopmentDashboardMobileReducer,
    bizDevelopmentAnomalies: bizDevelopmentAnomaliesReducer,
    leadsManagement: leadsManagementReducer,
    optifundDashboard: optifundDashboardReducer,
    brands: brandsReducer,
    deepView: deepViewReducer,
    advisor: advisorReducer,
    families: familiesReducer,
    fetcherSettings: fetcherSettingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
